import { defineStore } from 'pinia'

import ax from '@utils/axios'
import { handleError }from '@utils/helpers'

export const useVendorStore = defineStore('vendor', {
  state: () => {
    return {
      vendors: [],
    }
  },

  getters: {
    vendorCategories(state) {
      return state.vendors.map((vendor) => {
        return { value: vendor.id, label: vendor.name }
      })
    },
  },

  actions: {
    async fetchVendors() {
      try {
        const response = await ax.get('/v2/vendors')
        this.vendors = response.data
      }
      catch(error) {
        handleError(error)
      }
    },
  }
})
